/**
 * The four region groups a placement is in, by code, in the order the
 * customer's create form lists them. Distinct from the nine server tags the
 * regions catalogue describes: a tag is the operator's, a group is what the
 * customer chose and what a placement records.
 */
const GROUPS: { code: string; label: string }[] = [
  { code: "europe", label: "Europe" },
  { code: "america", label: "America" },
  { code: "asia", label: "Asia" },
  { code: "australia", label: "Australia" },
];

/** A group's name, the code itself for one we do not know, null for an untagged placement. */
export function groupLabel(code: string | null | undefined): string | null {
  if (!code) return null;
  return GROUPS.find((group) => group.code === code)?.label ?? code;
}

/** Group codes in the customer's order, labelled — for a list cell. */
export function groupLabels(codes: string[]): string[] {
  const rank = (code: string) => {
    const index = GROUPS.findIndex((group) => group.code === code);
    return index === -1 ? GROUPS.length : index;
  };
  return [...codes].sort((a, b) => rank(a) - rank(b)).map((code) => groupLabel(code) ?? code);
}
